import http from './_http'

const auth = {
  setAuth: (token) => { http.defaults.headers.common['Authorization'] = 'Bearer ' + token; },
  unsetAuth: () => { delete http.defaults.headers.common['Authorization']; },

  register : (m) => { return http.post('api/v3/auth/register', m)},

  login: (m) => { return http.post('api/v3/auth/login', m); },
  refresh: () => { return http.get('api/v3/auth/refresh/' + new Date().getTime()); },

  getProfile: () => { return http.get('api/v3/auth/profile'); },
  setProfile: (m) => { return http.post('api/v3/auth/profile', m); },


  // resetPassword : (m) => http.post('auth/regist/resetpw', m),
  // otp : (m) => { return http.post('auth/regist/otp', m)},
  // authOtp : (m) => http.post('auth/regist/authotp', m),
}

export default auth